<script>
import Location from "./Location";
import LocationsList from "./LocationsList";

export default {
  name: "Tabs",
  components: {
    location: Location,
    locations: LocationsList,
  },
  data() {
    return {
      tabWidth: 0,
      currentPos: 0,
    };
  },
  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.tabWidth = window.innerWidth;
    },
    scrollHandler(ev) {
      this.currentPos = Number(
        (ev.srcElement.scrollLeft / this.tabWidth).toFixed(0)
      );
    },
    goto(index) {
      this.$refs.tabs.scrollLeft = (index + 1) * this.tabWidth;
    },
  },
  watch: {
    currentPos() {
      this.$store.commit("setCurrentLocation", this.currentPos);
    },
  },
};
</script>
<template>
  <div class="tabs" ref="tabs" @scroll="scrollHandler">
    <div class="tab">
      <locations @goto="goto" />
    </div>
    <div
      v-for="(loc, index) in $store.state.locations"
      :key="index"
      class="tab"
    >
      <location
        :loc="loc"
        :index="index"
        :active="index + 1 === $store.state.currentLoc"
      />
    </div>
  </div>
</template>
<style lang="scss">
.tabs {
  height: 100%;
  width: 100%;
  display: flex;
  scroll-snap-type: x mandatory;
  overflow-x: scroll;
  overflow-y: none;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }

  .tab {
    height: 100%;
    width: 100%;
    flex: 0 0 auto;
    scroll-snap-align: start;
    overflow-y: scroll;
  }
}
</style>